import PhaseFour from "components/Participant/CompleteSelfServey/SurveyPhase/PhaseFour"
import React from "react"

const PhaseFourPage = () => {
    return (
        <React.Fragment>
            <PhaseFour />
        </React.Fragment>
        
    )
}
export default PhaseFourPage
